/* eslint-disable max-len */
export const getCycleStart = (negativeOffset=0) => {
  const cycleLength = 807500
  // const cycleLength = 10000
  const completedCycle = parseInt(Date.now() / cycleLength) * cycleLength - (negativeOffset * cycleLength)
  return completedCycle
}
